import { Loadable } from "recoil";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadableHasValue(loadable: Loadable<any>): boolean {
  return loadable.state === "hasValue";
}
